import React, { useRef } from "react";
import { useDraggable } from "@dnd-kit/core";

interface FieldChipProps {
    id: string;
    label: string;
    required: boolean;
    isSelected?: boolean;
    onTap?: (id: string) => void;
}

function FieldChip({ id, label, required, isSelected, onTap }: FieldChipProps) {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id });
    const pointerStart = useRef<{ x: number; y: number } | null>(null);

    return (
        <div
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            onPointerDown={(e) => {
                pointerStart.current = { x: e.clientX, y: e.clientY };
                listeners?.onPointerDown?.(e as any);
            }}
            onPointerUp={(e) => {
                if (pointerStart.current) {
                    const dx = e.clientX - pointerStart.current.x;
                    const dy = e.clientY - pointerStart.current.y;
                    // Only fire tap if pointer didn't move far (wasn't a drag)
                    if (Math.abs(dx) < 5 && Math.abs(dy) < 5) {
                        onTap?.(id);
                    }
                }
                pointerStart.current = null;
            }}
            role="button"
            aria-label={`${isDragging ? "Dragging" : isSelected ? "Selected" : "Drag"} ${label} field`}
            style={{
                padding: "4px 12px",
                borderRadius: 20,
                backgroundColor: required ? "#4f46e5" : "#6b7280",
                color: "#fff",
                fontSize: "0.75rem",
                fontWeight: 600,
                cursor: "grab",
                opacity: isDragging ? 0.4 : 1,
                userSelect: "none",
                whiteSpace: "nowrap",
                touchAction: "none",
                boxShadow: isSelected ? "0 0 0 2px #fff, 0 0 0 4px #4f46e5" : "none",
                transition: "box-shadow 0.15s",
            }}
        >
            {label}{required ? " *" : ""}
        </div>
    );
}

export default FieldChip;
